import InvoiceForm from 'app/components/InvoiceForm/InvoiceForm'
import { useNavigate } from 'react-router'
import useCreateInvoice from './hooks/useCreateInvoice'
import { Flex } from 'antd'

const InvoiceCreate = () => {
  const navigate = useNavigate()

  const { createInvoice } = useCreateInvoice({
    onSuccess: () => {
      navigate(`/`)
    },
  })

  return (
    <Flex vertical gap="1rem">
      <h2>Create a new invoice</h2>
      <InvoiceForm invoice={null} onSave={createInvoice} />
    </Flex>
  )
}

export default InvoiceCreate
